export default __webpack_public_path__ + "static/media/Mark-4-Blueprints-01.a701ba4b.jpg";